import {useEffect} from 'react';
import useLoading from '../../../hooks/useLoading.js';

/*
 * Loading da página pelo LoadingModal global (padrão UNAERP, front-02 §1.17);
 * o BlockUI fica só nas tabelas. A página junta os seus carregamentos
 * (requisições em paralelo, com estado próprio) num booleano e o modal fica
 * aberto enquanto qualquer um estiver ativo; ao sair da página, fecha.
 */
export default function useCarregamentoPagina(carregando) {
    const setLoading = useLoading();

    useEffect(() => {
        setLoading(!!carregando);
    }, [!!carregando]);

    useEffect(() => () => setLoading(false), []);
}
